export default __webpack_public_path__ + "static/sandySCA-852a3258c0346d9416acde335f0249bf.webp";